// extracted by mini-css-extract-plugin
export var table = "_y3-0";